// extracted by mini-css-extract-plugin
module.exports = {"price":"price_price__2fusG","from":"price_from__Bu45i","text":"price_text__3Xo1T","textBlue":"price_textBlue__1lsNT","textWhite":"price_textWhite__1T1PI","priceSmall":"price_priceSmall__3mZA5","fromSmall":"price_fromSmall__1gGMg"};
    if(module.hot) {
      // 1790670310065
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  